const lazyModules = require.context('/src/app/pages', true, /\.module\.ts$/);

export function importLazyModule(path: string): Promise<any> {
	try {
		// Remove 'src/' if necessary.
		if (path.startsWith('src/')) {
			path = path.slice(4);
		}

		// Add '.ts' file extension if it's missing.
		if (!path.endsWith('.ts')) {
			path += '.ts';
		}

		return lazyModules(path);
	} catch (error) {
		console.error("COULDN'T IMPORT LAZY MODULE", error);

		throw error;
	}
}



